export default {"src":"/_next/static/media/verified-icon.a048c257.svg","height":18,"width":18};